/* app/js/src/components/common/headphones-icon/headphones-icon.component.scss */
/*# sourceMappingURL=headphones-icon.component.css.map */
